export const fetchCodeforcesStats = async (username) => {
  if (!username) return null;
  
  try {
    // 1. Fetch user info (Rating, Rank, Max Rating, Avatar)
    const infoRes = await fetch(`https://codeforces.com/api/user.info?handles=${username}`);
    if (!infoRes.ok) throw new Error("Codeforces user info failed");
    const infoData = await infoRes.json();
    
    if (infoData.status !== "OK") {
      throw new Error(infoData.comment || "User not found");
    }
    const user = infoData.result[0];

    // 2. Fetch submissions to calculate unique solved problems
    const statusRes = await fetch(`https://codeforces.com/api/user.status?handle=${username}`);
    if (!statusRes.ok) throw new Error("Codeforces user status failed");
    const statusData = await statusRes.json();
    
    let solvedCount = 0;
    if (statusData.status === "OK") {
      const submissions = statusData.result;
      const solvedSet = new Set();
      submissions.forEach(sub => {
        if (sub.verdict === "OK" && sub.problem) {
          solvedSet.add(`${sub.problem.contestId}-${sub.problem.index}`);
        }
      });
      solvedCount = solvedSet.size;
    }

    return {
      username: user.handle,
      avatar: user.avatar,
      rating: user.rating || 'Unrated',
      maxRating: user.maxRating || 'Unrated',
      rank: user.rank ? user.rank.charAt(0).toUpperCase() + user.rank.slice(1) : 'Unrated',
      problemsSolved: solvedCount,
      url: `https://codeforces.com/profile/${user.handle}`
    };
  } catch (err) {
    console.error("Codeforces API Error:", err);
    throw err;
  }
};
